export default __webpack_public_path__ + "static/media/2425 spice rack top.35be15d3.png";